"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  level: 3,
  lat: 33.450701,
  lng: 126.570667,
  width: '500px',
  height: '500px',
  marker: {
    image: 'http://t1.daumcdn.net/mapjsapi/images/2x/marker.png',
    width: 29,
    height: 42
  }
};
exports.default = _default;